import React from 'react';
import { useHistory } from 'react-router-dom';

const SuccessPage = () => {
  const history = useHistory();

  const handleClose = () => {
    history.push('/'); // Navigate to the homepage
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-4">Payment Successful</h2>
        <div className="mb-4">
          <svg className="w-16 h-16 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-gray-600 mb-6">
          Your payment was successful. Please check your email for further instructions.
        </p>
        <button
          onClick={handleClose}
          className="w-full bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700"
        >
          Go back to Homepage
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;